import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Text, { H1, H2 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import RecommendedProduct, { InlineRecommendedProduct } from './components/RecommendedProduct'

const BOTRecommendedSearchResult = ({
  allTypes = [],
  titles,
  activeVehicle: {
    frontTireSize
  } = {},
  recommendedCount,
  isHorizontal,
  compatibilityLabel,
  compareTrayItems,
  colWidth,
  showInline,
  vehicleName,
  hasFilters,
  showNoEligibleTiresForPromo,
  resultsLabel
}) =>
  <>
    {
      !hasFilters && showNoEligibleTiresForPromo &&
      <NoEligibleTiresForPromoWrapper>
        <NoEligibleTiresForPromoHeading noMargin>
          There are no eligible tires for this promotion to fit your vehicle
        </NoEligibleTiresForPromoHeading>
        <NoEligibleTiresForPromoSubheading>
          Scroll down to see all Tires and Deals currently available for your vehicle
        </NoEligibleTiresForPromoSubheading>
      </NoEligibleTiresForPromoWrapper>
    }
    <HeadBlock>
      <Headline
        data-at-recommended-result-headline
        headline
        headline_narrow
        inline
        size={ 26 }
        noMargin>{`Recommended Results for your ${compatibilityLabel ? 'Vehicle' : 'Tire Size'}`}</Headline>

      <Compatibility data-add-search-result-compatibility>
        <Check asset="check-circle" margin="0 10px 0 0" />
        These items fit { compatibilityLabel || resultsLabel }
      </Compatibility>
      {
        <Grid>
          {
            allTypes.map((product = {}, index) =>
              <Cell key={ product.skuId } colWidth={ colWidth }>
                { showInline ?
                  <InlineRecommendedProduct
                    { ...product }
                    key={ product.skuId || index }
                    index={ index }
                    isHorizontal={ isHorizontal }
                    title={ titles[product.type] }
                    compareTrayItems={ compareTrayItems }
                    vehicleName={ vehicleName } /> :
                  <RecommendedProduct
                    { ...product }
                    recommendedCount={ recommendedCount }
                    index={ index }
                    title={ titles[product.type] }
                    compareTrayItems={ compareTrayItems }
                    vehicleName={ vehicleName } />
                }
              </Cell>
            )
          }
        </Grid>
      }
    </HeadBlock>
  </>

export default BOTRecommendedSearchResult

BOTRecommendedSearchResult.propTypes = {
  activeVehicle: PropTypes.shape(),
  allTypes: PropTypes.arrayOf(PropTypes.shape()),
  colWidth: PropTypes.string,
  compareTrayItems: PropTypes.arrayOf(PropTypes.shape()),
  compatibilityLabel: PropTypes.string,
  defaultQuantityValue: PropTypes.number,
  hasFilters: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  recommendedCount: PropTypes.number,
  resultsLabel: PropTypes.string,
  showInline: PropTypes.bool,
  showNoEligibleTiresForPromo: PropTypes.bool,
  titles: PropTypes.shape(),
  vehicleName: PropTypes.string
}

const HeadBlock = styled.div`
  margin-bottom: 30px;
  ${Mixin.clearFix()}
  padding: 25px 25px 35px;
  background-color: #f2f2f2;
  ${Media.mobile`
    padding: 15px 15px 10px 15px;
  `}
`

const Headline = styled(H1)`
  max-width: 480px;
  word-wrap: break-word;
  ${Media.desktop`
    margin-bottom: 20px;
  `}
  ${Media.mobile`
    display: block;
    font-size: 20px;
  `}
`

const Compatibility = styled.div`
  position: relative;
  display: inline-block;
  padding: 13px 0 0;
  line-height: 22px;
  color: ${Theme.colors.green};
  vertical-align: top;
  ${Mixin.font.GothamBold(16)}
  ${Media.desktop`
    float: right;
  `}
  ${Media.mobile`
    margin-bottom: 18px;
    padding: 13px 0 0 24px;
  `}
`

const Check = styled(Icon)`
  ${Media.mobile`
    position: absolute;
    top: 18px;
    left: 0;
    max-width: 16px;
  `}
`

const Cell = styled.div`
  vertical-align: top;
  flex: 1;
  ${Mixin.responsive('padding', '0 12px', '0')}
  ${Mixin.responsive('display', 'inline-block', 'block')}
  ${props => props.colWidth && css`
    width: ${props.colWidth || '25%'};
  `}
  ${Media.mobile`
    margin: 0 0 20px;
    width: 100%;
  `}
`

const Grid = styled.div`
  width: auto;
  display: flex;
  ${Mixin.responsive('margin', '0 -12px', '0')}
  ${Media.mobile`
    padding: 0 5px;
    display: block;
  `}
`

const NoEligibleTiresForPromoWrapper = styled.div`
  text-align: center;
  margin: 30px 0 55px;
`
const NoEligibleTiresForPromoHeading = styled(H2)`
  ${Mixin.font.GothamBold(24)}
  text-transform: uppercase;
  font-stretch: condensed;
  margin-bottom: 15px;
  transform: scale(1, 1.3);
  letter-spacing: 0;
`

const NoEligibleTiresForPromoSubheading = styled(Text)`
  ${Mixin.font.GothamBold(14)}
  letter-spacing: 0;
  line-height: 1.3em;
`
